//
//  @component: shows authorized deleagtes for submission, and returns selected delegate
//  @author: jC
//
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';

import { UserService } from '@app/core';
import { Transaction } from '../enums/txn-type.enum';
import { CommonDataService } from '../services/common-data.service';
import { SubmittedForDataService } from './submitted-for-data.service';
import { UserSummary } from '../classes/user';
import { Validation } from '@app/shared';
import {ControlValueAccessor} from "@angular/forms";
import {plainToClass} from "class-transformer";

@Component({
  selector: 'app-submitted-for',
  templateUrl: './submitted-for.component.html',
  styleUrls: ['./submitted-for.component.css'],
  providers: [SubmittedForDataService]
})

export class SubmittedForComponent implements OnInit, OnChanges {

  Validation: typeof Validation = Validation;

  delegates: SelectItem[];
  suggestedDelegates: SelectItem[];
  selectedDelegate: UserSummary;
  delegateNotFound: boolean = false;
  orignialSubmittedForUser: UserSummary;


  @Input() txnType: Transaction;
  @Input() submittedForId: number;        // The submitted for is modelled on a different variable than the entity one to prevent circular loop
  @Input() editable: boolean = true;

  // returns selected user; if no delegates are available, return the user himself
  @Output() handler: EventEmitter<UserSummary> = new EventEmitter();

  constructor (private commonDataService: CommonDataService, private user: UserService, private dataService: SubmittedForDataService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {

    this.delegateNotFound = false;

    if (!this.orignialSubmittedForUser || this.orignialSubmittedForUser.id != this.submittedForId) {
      this.getSubmittedForUser(this.submittedForId);
    }


    if (this.delegates) {
      if (this.submittedForId && this.selectedDelegate && this.submittedForId != this.selectedDelegate.id) {
        this.setSelectedDelegate(this.submittedForId);
      } else {
        console.log(`userId (${this.submittedForId}) is same as the selectedDelegate. nothing to do here...`);
      }
    } else {
      this.getDelegates(this.txnType, this.submittedForId);
    }

  }

  setSelectedDelegate(userId: number) {
    let index = this.delegates.findIndex(del => del.value && del.value.id == userId);

    if (index >= 0) {
      this.selectedDelegate = this.delegates[index].value;
      this.onChangeDelegate(this.selectedDelegate);
    } else {
      this.selectedDelegate = this.delegates[0].value;
      this.delegateNotFound = true;
      this.onChangeDelegate(this.selectedDelegate);
      console.warn(`could not find userId (${userId}) from the delegate list`);
    }
  }

  getSubmittedForUser(userId: number) {
    if (!userId) {
      return;
    }
    this.commonDataService.getUserById(userId).subscribe(res => {
      this.orignialSubmittedForUser = plainToClass(UserSummary , res as UserSummary);
    });
  }

  /**
   * @desc get authorized delegation for specific txn type or id
   * @returns this.delegates - delegates for the specified transaction type or id
   */
  getDelegates(txnType: Transaction, userId: number) {

    this.dataService.getSubmittedForAsDropDown(txnType).subscribe(res => {

      this.delegates = res;
      const fullName = this.user.info.fullName;
      const loginUserId = this.user.info.userId;
      this.delegates.unshift({ label: fullName, value: { fullName: fullName, id: loginUserId } });

      if (userId) {
        this.setSelectedDelegate(userId);
      } else {
        this.setSelectedDelegate(loginUserId);
      }

    });
  }

  /**
   * @desc a delegate is selected, return the selected delegate
   * @param selectedDelegate - user selected delegate
   */
  onChangeDelegate(selectedDelegate: UserSummary) {
    this.handler.emit(selectedDelegate);
  }
}
